import { Avatar, IconButton } from "@mui/material";

export default function ContactAvatar({ photoURL, classes, action, disableButton }) {
  const avatarMarkup = <Avatar src={photoURL} className={classes.avatar} />;

  return (
    <IconButton
      onClick={action}
      size="large"
      style={{
        pointerEvents: disableButton && "none",
      }}
    >
      {avatarMarkup}
    </IconButton>
  );
}
